export enum ETipoElementoGrupoCampos {
    Aba = 1,
    Painel = 2,
}
